<template>
  <div class="reportTable">
    <!-- F31 -->
    <section ref="print">
      <div class="mytitle">
        <ul>
          <li>
            <span>打印日期：</span>
            <span>{{ $parent.nowday }}</span>
          </li>
          <li>
            <span>打印时间：</span>
            <span>{{ $parent.nowtime }}</span>
          </li>
          <li>
            <span>酒店日期：</span>
            <span>{{ $parent.hotelInfo.dhoteltime }}</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span></span>
            <span>{{ $parent.hotelInfo.cname }}</span>
          </li>
          <li>
            <span></span>
            <span>{{ $parent.bbmc }}</span>
          </li>
          <li>
            <span>查询日期：</span>
            <span>
              {{ this.$moment(this.$parent.startDate).format("YYYY-MM-DD") }}
            </span>
            <span v-if="$parent.endTimeShow">
              至{{ this.$moment(this.$parent.endDate).format("YYYY-MM-DD") }}
            </span>
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>{{ $parent.userInfo.cname }}</span>
          </li>
          <!-- <li>
            <span>总页数:</span>
            <span>{{pagecount}}</span>
        </li>-->
          <li v-if="$parent.datacount > 0">
            <span>总条数:</span>
            <span>{{ $parent.datacount }}条</span>
          </li>
        </ul>
      </div>
      <div class="report">
        <!-- <div class="title-label">F31.日志查询</div> -->
        <!-- <div class="form-content">
        <ul class="formTitle">
          <li>房号</li>
          <li>账号</li>
          <li>姓名</li>
          <li>操作时间</li>
          <li>酒店时间</li>
          <li>原值</li>
          <li>新值</li>
          <li>操作员</li>
        </ul>
      </div>
      <div class="formContaniner">
        <transition-group name="registeredList" tag="p">
          <div
            class="PreArrivalItem"
            v-for="(item, index) in allTableData"
            :key="item.id"
          >
            <div>{{ index + 1 }}</div>
            <div>{{ item.description }}</div>
            <div>{{ item.disporder }}</div>
          </div>
        </transition-group>
      </div> -->
        <table style="border-collapse: collapse" align="center" width="100%">
          <thead>
            <tr>
              <th>卡类型</th>
              <th>会员账号</th>
              <th>会员卡号</th>
              <th>会员名称</th>
              <th>销售员</th>
              <th style="text-align:right">信用</th>
              <th style="text-align:right">定金</th>
              <th style="text-align:right">结余</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="item in allTableData">
              <tr>
                <td style="text-align: left">
                  {{ item.memberTypeName }}
                </td>
              </tr>
              <tr v-for="(itemList, indexList) in item.list">
                <td>{{ itemList.memberTypeName }}</td>
                <td>{{ itemList.accNo }}</td>
                <td>{{ itemList.cardNo }}</td>
                <td>{{ itemList.name }}</td>
                <td></td>
                <td style="text-align:right">{{ $parent.curreny(itemList.addAmount )}}</td>
                <td style="text-align:right">{{$parent.curreny( itemList.amount )}}</td>
                <td style="text-align:right">{{$parent.curreny( itemList.useAmount) }}</td>
                {{
                  getAllCount(item)
                }}
              </tr>
              <tr style="font-weight: 800">
                <td style="text-align: left; font-weight: 800">
                  {{ item.memberTypeName }}
                </td>
                <td style="font-weight: 800" colspan="4">
                  <div class="topDeshed"></div>
                </td>
                <td style="font-weight: 800;text-align:right">{{$parent.curreny( item.addAmount )}}</td>
                <td style="font-weight: 800;text-align:right">{{ $parent.curreny(item.amount) }}</td>
                <td style="font-weight: 800;text-align:right">{{ $parent.curreny(item.useAmount) }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import { postRequest, getRequest } from "@/api/api1.js";
export default {
  data() {
    return {
      // 未处理数据
      preArrivalList: [],
      // 记录
      record: 0,
      room: 0,
      total: 0,
      allPage: 0,
      userName: localStorage.getItem("cname"),
      time: this.$moment(new Date()).format("YYYY-MM-DD"),
      tableVipType: "",
      tableTypeList: [],
      tableVipAcc: "",
      tableAccList: [],
      // 筛选数据
      allTableData: [],
      queryDate: "",
    };
  },
  created() {
    this.$parent.closeshow();
    this.$parent.bbmc = "A20.会员账户欠款结余报表";
    this.$parent.startDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.queryDate = new Date();
    this.getPreArrivalList();
    this.$parent.startTimeShow = true;
    // this.$parent.endTimeShow = false;
    // this.$parent.showCzy = false;
    // this.$parent.showBc = false;
    // this.$parent.showZx = false;
    
    this.$parent.chaxunvib = true;

    // 
  },
  methods: {
    dodayin() {
      this.$print(this.$refs.print);
    },
    doserach() {
      this.getPreArrivalList();
    },
    getPreArrivalList() {
      let loadingInstance = this.$loading({ text: "正在查询..." });
      postRequest("/reportForMembers/selectMemberArrears", {
        time: this.time,
      }).then((res) => {
        
        this.$nextTick(() => {
          loadingInstance.close();
        }); //不回调
        if (res.status != 200)
          return vm.$mymessage({
            content: res.code,
            type: "error",
            time: 3000,
            hasClose: true,
          });
        this.$parent.datacount = res.data.length;
        this.preArrivalList = res.data;
        this.$store.state.preArrivalList = res.data;
        this.$store.state.preArrivalName = "A20.会员账户欠款结余报表";
        let allList = [...res.data];
        this.tableTypeList = Array.from(
          new Set(allList.map((item) => item.memberTypeName))
        );
        this.tableAccList = Array.from(
          new Set(allList.map((item) => item.accNo))
        );
        this.selectVipType();
        this.$forceUpdate();
      });
    },
    // 根据操作员筛选
    selectVipType() {
      this.allTableData = [];
      if (!this.tableVipType) {
        this.tableTypeList.filter((item) => {
          this.allTableData.push({
            memberTypeName: item,
            list: [...this.preArrivalList]
              .filter((itemList) => {
                return itemList.memberTypeName == item;
              })
              .filter((itemList) => {
                if (!this.tableVipAcc) return true;
                return itemList.accNo == this.tableVipAcc;
              }),
          });
        });
      } else {
        this.allTableData.push({
          memberTypeName: this.tableVipType,
          list: [...this.preArrivalList]
            .filter((itemList) => {
              return itemList.memberTypeName == this.tableVipType;
            })
            .filter((itemList) => {
              if (!this.tableVipAcc) return true;
              return itemList.accNo == this.tableVipAcc;
            }),
        });
      }
    },
    // 小计
    getAllCount(val) {
      val.addAmount = 0;
      val.amount = 0;
      val.useAmount = 0;
      val.list.filter((item) => {
        val.addAmount += item.addAmount;
        val.amount += item.amount;
        val.useAmount += item.useAmount;
      });
      
    },
  },
  watch: {
    time: {
      handler(n, o) {
        this.getPreArrivalList();
      },
    },
  },
};
</script>
<style scoped >
td {
  text-align: center;
}
.mytitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px !important;
  line-height: 24px;
  margin-bottom: 1em;
}
</style>